export default class Cookies {
  constructor() {
    this.cookies = document.querySelector('[data-cookies]');
    this.storage = window.localStorage.getItem('cookies-accepted');

    if (this.cookies) {
      this.accept = this.cookies.querySelector('[data-cookies-button]');
      this._init();
    }
  }

  _init() {
    if (this.storage) {
      return;
    }

    this._showCookies();
    this.accept.addEventListener('click', this._acceptCookies.bind(this));
  }

  _showCookies() {
    this.cookies.classList.add('cookies--visible');
    this.cookies.setAttribute('aria-hidden', false);
  }

  _acceptCookies() {
    window.localStorage.setItem('cookies-accepted', true);
    this.cookies.classList.remove('cookies--visible');
    this.cookies.setAttribute('aria-hidden', true);
  }
}
